import Turn, { RoundTurn } from "../store/game/types/Turn";

export default function isRoundTurn(turn: Turn | null): turn is RoundTurn {
  return turn !== null && "callAmount" in turn;
}
